export function safePercent(value: number, fallback: number) {
  return Number.isFinite(value) ? Math.min(99, Math.max(1, value)) : fallback;
}

/** 保存偏好比例，但视口变窄时只约束显示值，不覆盖用户的大屏偏好。 */
export function splitGeometry(
  available: number,
  percent: number,
  firstMinimum: number,
  secondMinimum: number,
) {
  const total = Math.max(0, available);
  const fits = total >= firstMinimum + secondMinimum;
  const min = fits ? firstMinimum : 0;
  const max = fits ? total - secondMinimum : total;
  const value = Math.max(
    min,
    Math.min(max, (total * safePercent(percent, 50)) / 100),
  );
  return { fits, min, max, value };
}
